import { HEADER_HEIGHT } from 'config/themeTokens';

/**
 * 壳层几何尺寸，需与 src/styles/shell.less 中的同名 less 变量保持一致。
 *
 * @zhiyue/core 1.2.0 的调宽实现仍按 248px / 180–360px / 56px 页头计算，
 * 不满足导航布局规范，因此这里保留应用侧实现，仅沿用平台的存储键。
 */
export { HEADER_HEIGHT };
export const DEFAULT_SIDER_WIDTH = 208;
export const MIN_SIDER_WIDTH = 180;
export const MAX_SIDER_WIDTH = 260;
/** ProLayout 原生折叠宽度为 64px，不可配置；低于该阈值视为已折叠。 */
export const COLLAPSED_SIDER_THRESHOLD = 90;
export const RESIZE_HANDLE_HITBOX = 12;
export const COLLAPSE_TRIGGER_SAFE_GAP = 12;
export const RESIZE_KEYBOARD_STEP = 8;
export const RESIZE_KEYBOARD_STEP_LARGE = 24;
/** 低于该视口宽度时 ProLayout 切换为移动抽屉，调宽热区不再挂载。 */
export const MOBILE_BREAKPOINT = 768;
export const SIDER_WIDTH_STORAGE_KEY = 'easy-record:sider-width:v2';

export const clampSiderWidth = (width: number) =>
  Math.min(MAX_SIDER_WIDTH, Math.max(MIN_SIDER_WIDTH, Math.round(width)));

export const getStoredSiderWidth = (): number => {
  if (typeof window === 'undefined') {
    return DEFAULT_SIDER_WIDTH;
  }

  try {
    const raw = window.localStorage.getItem(SIDER_WIDTH_STORAGE_KEY);
    // Number(null) === 0，不先判空会把「没有偏好」误当成最小宽度
    if (raw === null || raw.trim() === '') {
      return DEFAULT_SIDER_WIDTH;
    }
    const width = Number(raw);
    return Number.isFinite(width)
      ? clampSiderWidth(width)
      : DEFAULT_SIDER_WIDTH;
  } catch {
    return DEFAULT_SIDER_WIDTH;
  }
};

export const persistSiderWidth = (width: number) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(
      SIDER_WIDTH_STORAGE_KEY,
      String(clampSiderWidth(width)),
    );
  } catch {
    // 隐私模式下不可写时仅本次会话生效
  }
};

/**
 * 内容区独立滚动后，页面不再随 window 滚动；Affix、Anchor 等
 * 依赖滚动容器的组件需以此作为 target / getContainer。
 */
export const getLayoutScrollContainer = (): HTMLElement | Window =>
  document.querySelector<HTMLElement>('.ant-pro-layout-content') || window;
